import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Card, Grid, Container } from 'semantic-ui-react';
import { useIntl, FormattedMessage, defineMessages } from 'react-intl';
import { UniversalLink, PreviewImage } from '@plone/volto/components';
import { getVocabulary } from '@plone/volto/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { map } from 'lodash';
import { formatDate } from '../../../helpers'

const messages = defineMessages({
  servicesTitle: {
	id: 'Serveis',
	defaultMessage: 'Serveis',
  },
});

const NewsItemDate = ({ date }) => {
  const [formattedDate, setFormattedDate] = useState('');

  useEffect(() => {
    if (date) {
      setFormattedDate(formatDate(date));
    }
  }, [date]);

  return formattedDate && (
    <time className="newsItem__date" dateTime={date}> 
      {formattedDate}
    </time>
  );
};


const NewsListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {

	let href = (linkHref?.[0]?.['@id']) || '';
	let link = href ? flattenToAppURL(href) : '';
	const intl = useIntl();


	const vocabularySubjects = 'plone.app.vocabularies.Keywords';
	const dispatch = useDispatch();
	const itemsSubjects = useSelector(
		(state) =>
			state.vocabularies[vocabularySubjects] && state.vocabularies[vocabularySubjects].items
				? [...state.vocabularies[vocabularySubjects].items]
				: [],
		shallowEqual,
	);

	useEffect(() => {
		dispatch(getVocabulary({ vocabNameOrURL: vocabularySubjects }));
	}, [dispatch]);

	const getNewsItemDate = function (effective) {
		const date = formatDate(effective)
		return date
	}

	const getNewsItemSubject = function (subject) {
		if (!itemsSubjects) {
			return subject
		}
		for (let item of itemsSubjects) {
			if (item.value === subject) return item.label
		}
		return subject
	}

	return (
		<Container >
			{blockTitle && <h3 className="newsListing__title mt-0">{blockTitle}</h3>}			
			<Grid columns={12} as="ul" className='list-unstyled newsListing'>
				{items.map((item) => (
					<Grid.Column as="li" mobile={12} tablet={6} computer={4} widescreen={4} largeScreen={4} key={item['@id']} >

						<Card fluid as="article" className="newsItem position-relative">
							{item.image_field && (
								<div className='newsItem__figure'>
									<PreviewImage
										className="newsItem__img m-0 image"
										item={item}
										alt={item.image_caption ? item.image_caption : ''}
										sizes="(max-width: 767px) 100vw, (max-width: 991px) 50vw, 33.33vw"
									/>
								</div>
							)}
							<Card.Content className=" newsItem__text">
								<Card.Meta className=" newsItem__extra ">													
									<NewsItemDate date={item.effective} />

									{item?.Subject && (
										<ul className='newsItem__subject list-unstyled my-0 ms-auto' aria-label={intl.formatMessage(messages.servicesTitle)}>												
											{map(item.Subject.slice(0, 1), (item, index) => (
												<li key={item}>
													{link ? (
													<UniversalLink 
														href={`${link}?category=${encodeURIComponent(item)}`} 
														className="newsItem__subject__item"
													>
														{getNewsItemSubject(item)}
													</UniversalLink>
													) : (
													<span className="newsItem__subject__item">
														{getNewsItemSubject(item)}
													</span>
													)}
												</li>
											))}
										</ul>
									)}
								</Card.Meta>
								<Card.Header as="h3" className="newsItem__title">
									<UniversalLink href={flattenToAppURL(item['@id'])} className="newsItem__link stretched-link">{item.title}</UniversalLink>
								</Card.Header>
								{item?.description &&
									<Card.Description as="p" className="newsItem__desc mt-0">
										{item.description}
									</Card.Description>
								}
								<div className="text-end mt-auto">
									<FontAwesomeIcon icon={faArrowRight} />
								</div>					
							</Card.Content>
						</Card>

					</Grid.Column>
				))}
			</Grid>

			{link &&
				<p className="readMoreItem d-print-none text-center mt-3 mb-0">
					<UniversalLink href={link} className="readMoreItem__btn ui button primary">
						{linkTitle ? (
							<span>{linkTitle}</span>
						) : (
							<>
								<FormattedMessage id="See all" defaultMessage="See all" />
								<span className="visually-">{blockTitle}</span>
							</>
						)}
					</UniversalLink>
				</p>
			}
			
		</Container>
	);
}

NewsListing.propTypes = {
	linkHref: PropTypes.arrayOf(PropTypes.any),
	items: PropTypes.arrayOf(PropTypes.any).isRequired,
	linkMore: PropTypes.any,
	isEditMode: PropTypes.bool,
};

export default NewsListing;
